import { toast } from 'react-toastify';
import '../assets/style/aboutTwo.scss';
import iconMail from '../assets/images/mail.svg';
import iconTelegram from '../assets/images/telegram.svg';
import iconViber from '../assets/images/viber.svg';

const AboutTwo = () => {
  const notifyTelegram = () => {
    const toastId = 'my-custom-toast-I';

    if (!toast.isActive(toastId)) {
      toast.info('Ensure that Telegram is installed on your device to maintain contact.', {
        toastId,
        position: 'top-center',
        autoClose: 2500,
        hideProgressBar: false,
        newestOnTop: false,
        closeOnClick: true,
        rtl: false,
        theme: 'light',
      });
    }
  };

  const notifyViber = () => {
    const toastId = 'my-custom-toast-II';

    if (!toast.isActive(toastId)) {
      toast.info('Ensure that Viber is installed on your device to maintain contact.', {
        toastId,
        position: 'top-center',
        autoClose: 2500,
        hideProgressBar: false,
        newestOnTop: false,
        closeOnClick: true,
        rtl: false,
        theme: 'light',
      });
    }
  };

  return (
    <div className="about-me__container">
      <div className="about-me__row">
        <div className="about-me__first">
          <p>
            As a visionary in his field, Said, a 24-year-old full-stack developer
            from Bosnia, navigates the realms of technology and creativity with mastery.
            His innovative approach drives solutions, inspiring greatness in individuals and teams.
          </p>
          <div className="icons-list">
            <a className="mail-button" href="mailto:saidrasinlic@outlook.com">
              <img src={iconMail} alt="mail" />
              {/* <a href="mailto:saidrasinlic@outlook.com">
              <img src={iconMail} alt="mail" /></a> */}
              {/* <ToastContainer
                position="bottom-center"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              /> */}
            </a>
            <a
              className="mail-button"
              onClick={notifyTelegram}
              href="https://telegram.me/saidrasinlic"
              target="_blank"
              rel="noreferrer"
            >
              <img src={iconTelegram} alt="mail" />
            </a>
            <a
              className="mail-button"
              onClick={notifyViber}
              href="viber://chat?number=%2B38761022586"
            >
              <img src={iconViber} alt="mail" />
            </a>
          </div>
        </div>
        <div className="about-me__second">
          <h1>
            about
            <br />
            Said Rašinlić
          </h1>
        </div>
      </div>
    </div>
  );
};

export default AboutTwo;
